function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M17.5,5.2L17.5,5.2l-3.7-3.7l-1.1,1.1l2.1,2.1C13.9,5,13.2,5.9,13.2,7c0,1.4,1.1,2.5,2.5,2.5 c0.4,0,0.7-0.1,1-0.2v7.2c0,0.5-0.5,1-1,1c-0.6,0-1-0.5-1-1V12c0-1.1-0.9-2-2-2h-1V3c0-1.1-0.9-2-2-2h-6c-1.1,0-2,0.9-2,2v16h10 v-7.5h1.5v5c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5V7C18.2,6.3,18,5.7,17.5,5.2z M9.8,11.5V17h-6v-7h6V11.5z M9.8,8h-6V3h6V8z  M15.8,8c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.5,0,1,0.4,1,1S16.3,8,15.8,8z"
});

var SvgGallonsUsed = function SvgGallonsUsed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGallonsUsed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gallons_used.764532eb.svg";
export { ForwardRef as ReactComponent };